<template>
    <div class="border-gold-lighter mt-4 border-t-2">
        <template v-if="currentRestaurants.length">
            <ol :class="[numPages > 1 ? 'pb-0' : 'pb-24']">
                <RestaurantsListItem v-for="(restaurant, index) in currentRestaurants" v-bind="restaurant" :key="`restaurant-list-${restaurant.id}`" :index="index" />
            </ol>
        </template>

        <div v-else class="py-16 text-center">
            <div class="h2 text-3xl">No results found.</div>
            <div class="mb-6">We were unable to locate any results for your search.</div>

            <UiButton href @click.prevent="reset">Reset Search</UiButton>
        </div>
    </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useRestaurantsListStore } from '../../stores/restaurant-list-store';
import RestaurantsListItem from './RestaurantsListItem.vue';
import UiButton from '../Ui/UiButton.vue';
import { useRestaurantsListSearchStore } from '../../stores/restaurant-list-search-store.js';

const store = useRestaurantsListStore();
const searchStore = useRestaurantsListSearchStore();

const { currentRestaurants, numPages } = storeToRefs(store);
const { reset } = searchStore;
</script>
